export const extractNumberFromX = (x: number | string | Date, granularity: string = "") => {
    if (x instanceof Date) {
        const nx = x.getTime();
        // console.log(`extracted ${nx} from ${x}`);
        return nx;
    }
    if (typeof x === "string") return 0;
    return x;
};
